import { css } from '@emotion/core';
import MediaQueries from '../../../../styles/Grid/MediaQueries';
import { colorsPalette, shadows } from '../../../../styles/colors';
import { typography, fontWeights } from '../../../../styles/typography';

const headerFont = css(typography.effra22, {
  color: colorsPalette.black,
  fontWeight: fontWeights.medium,
  [MediaQueries.mdAndUp]: {
    ...typography.effra34,
    fontWeight: fontWeights.regular,
  },
});

export const contentStyles = {
  border: 0,
  overflow: 'visible',
  padding: 0,
  position: 'static',
};

export const overlayStyles = {
  backgroundColor: 'rgba(51, 51, 51, 0.9)',
  bottom: 0,
  left: 0,
  right: 0,
  top: 0,
  zIndex: 10,
};

export const sidePanel = css({
  background: colorsPalette.white,
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  minHeight: '100vh',
  overflowY: 'scroll',
  position: 'absolute',
  right: 0,
  top: 0,
  '.is-IE &': {
    display: 'block',
  },
});

// Generate space to avoid content being overlapped when user has scrolled down.
// Eyeballed value of the max height expected for the footer.
const footerHeight = 110;

export const sidePanelNarrow = css({
  paddingBottom: footerHeight,
  '@supports(-webkit-touch-callout: none)': {
    paddingBottom: 220,
  },
  [MediaQueries.mdAndUp]: {
    paddingBottom: footerHeight,
  },
});

export const headerWrapper = css(headerFont, {
  marginBottom: 32,
  [MediaQueries.mdAndUp]: {
    maxWidth: 400,
  },
});

export const closeButton = css({
  alignItems: 'center',
  background: colorsPalette.transparent,
  border: 0,
  display: 'flex',
  padding: 0,
  position: 'absolute',
  right: 24,
  textAlign: 'center',
  top: 24,
  cursor: 'pointer',

  [MediaQueries.mdAndUp]: {
    right: 40,
    top: 52,
  },

  [MediaQueries.lgAndUp]: {
    right: 78,
  },

  [MediaQueries.xl]: {
    right: 82,
  },
});

export const closeIcon = css({
  cursor: 'pointer',
  fontSize: 18,
  fontWeight: fontWeights.medium,
  marginRight: 8,
  marginTop: -2,

  [MediaQueries.mdAndUp]: {
    marginRight: 0,
    marginTop: 0,
  },
});

export const closeText = css(typography.effra16, {
  color: colorsPalette.black,
});

export const footer = css({
  backgroundColor: colorsPalette.white,
  bottom: 0,
  boxShadow: shadows.shadow80,
  paddingBottom: 16,
  paddingTop: 16,
  position: 'fixed',
  right: 0,

  [MediaQueries.mdAndUp]: {
    paddingBottom: 16,
    paddingTop: 16,
  },
});

export const bodyWrapper = css({
  '.is-IE &': {
    paddingBottom: footerHeight,
  },
});
